import { useState, useEffect } from "react";
import axios from "axios";
import keys from "lodash/keys";

const useGet = (url, options = {}, afterSuccess = null, afterError = null) => {
  const [loading, setLoading] = useState(null);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  let params = [];

  if (options.params) {
    params = keys(options.params);
  }

  useEffect(() => {
    get();

    return function cleanup() {
      setResponse(null);
      setLoading(null);
      setError(null);
      cancel();
    };
  }, [url, options.params, ...params]);

  const cancelToken = axios.CancelToken.source();

  const get = async () => {
    setLoading(true);
    setResponse(null);
    setError(null);

    await axios
      .get(url, {
        params: options.params,
        cancelToken: cancelToken.token,
      })
      .then((response) => {
        setResponse(response);
        setError(null);

        if (afterSuccess) {
          afterSuccess(response);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.warn("Request canceled");
        } else {
          setError(error);
          setResponse(null);

          if (afterError) {
            afterError(error);
          }
        }
      });

    setLoading(false);
  };

  const cancel = () => {
    cancelToken.cancel();
  };

  return [loading, response, error, cancel];
};

export default useGet;
